import { ActionNames } from '../actions';
export default function (state = {}, action) {
    switch (action.type) {
        case ActionNames.SOCIAL_LOGIN: {
            return {};
        }
    }
    return state;
}